import { AfterViewInit, Component, input, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { NgControl, FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

import { ApContentService } from '@ap/content';
import { AbstractInputComponent, ApOptions, InputmodeType } from '@ap/input';
import { ApInputConstraintService } from '@ap/input/constraint';
import { ApActivationCodeValidator } from '@ap/input/validators';
import { ApFormErrorsComponent } from '@ap/form/errors';

import content from './activation-code-input.content.json';

@Component({
    selector: 'ap-activation-code-input',
    templateUrl: './activation-code-input.component.html',
    styleUrls: ['../../../src/lib/input.component.scss', './activation-code-input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, ApFormErrorsComponent, NgTemplateOutlet, NgTemplateOutlet],
    providers: [ApInputConstraintService]
})
export class ApActivationCodeInputComponent extends AbstractInputComponent implements OnInit, AfterViewInit {
    protected control = inject(NgControl, { self: true, optional: true });
    protected readonly inputConstraintService = inject(ApInputConstraintService);
    protected readonly contentService = inject(ApContentService);

    /**
     * Maxlength of a activation code is 6
     */
    protected readonly maxlength = input<number>(6);

    /**
     * Only numbers allowed
     */
    protected readonly stripPattern = input<RegExp>(/[^\d]/g);

    /**
     * Inputmode (Standard HTML inputmode types)
     */
    protected readonly inputmode = input<InputmodeType>('numeric');

    protected stripes: number[];

    override readonly options = input<ApOptions>(null);

    constructor() {
        super();
        this.setDefaultContent(content, 'activation-code-input');
    }

    /**
     * Handle change of input
     * Override standard input change to set stripes
     */
    protected override onInputChange(event: Event): void {
        super.onInputChange(event);
        this.stripes = this.drawStripes();
    }

    /**
     * On init set active stripes
     */
    public ngOnInit(): void {
        this.stripes = this.drawStripes();
    }

    /**
     * After init bind the control validation
     */
    public ngAfterViewInit(): void {
        const control = this.control?.control;
        if (control) {
            control.addValidators([ApActivationCodeValidator.validate]);
            control.updateValueAndValidity();
        }
    }

    /**
     * Draw correct stripes
     */
    private drawStripes(): number[] {
        const length = this.value?.length || 0;
        return Array.from({ length: 6 }, (_, index) => (index >= length ? index : -1));
    }
}
